var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image-viewer',{attrs:{"v-if":_vm.syncedVisible,"url-list":_vm.urlList,"z-index":_vm.zIndex,"on-switch":_vm.onSwitch,"initial-index":_vm.initialIndex,"on-close":_vm.doClose}})}
var staticRenderFns = []

export { render, staticRenderFns }